// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
// import get from 'lodash/get';
// import adsConfig from '../../../config/ads';
// import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  // const { store } = action;
  const typeMap = {
    INNOVATION_BY_DESIGN_APPLY_LOADING() {
      console.log('IBD APPLY_PAGE REDUCER loading action object ', action);
      return {
        isLoading: true,
        innovationByDesignApply: action.innovationByDesignApply,
        allRendered: false
      };
    },
    INNOVATION_BY_DESIGN_APPLY_LOADED() {
      // const currentState = store.getState();
      // const site = get(currentState, 'config.site') || 'fastcompany';
      // const adModelData = buildPostAdModel(
      //   adsConfig,
      //   site,
      //   'innovation-by-design',
      //   'categoryPage'
      // );
      console.log(
        'IBD APPLY_PAGE REDUCER loaded Object.keys(Action) -> ',
        Object.keys(action),
        ' \n action.innovationByDesignApply  ',
        action.innovationByDesignApply
      );

      // adModelData.model.adzone = 'innovation/innovation-by-design';
      return {
        isLoading: false,
        data: action.innovationByDesignApply,
        allRendered: false
      };
    },
    INNOVATION_BY_DESIGN_APPLY_ERROR() {
      console.log('IBD APPLY_PAGE REDUCER error action -> ', action);
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignApply.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
